import type { LookoRouteObject } from '../LookoRouteObject';
import { sellerMap } from '../managementMaps';

// 마이페이지
const sellerRoutes: LookoRouteObject[] = [
  {
    path: sellerMap['create-mapping-group'].path,
    async lazy() {
      const { default: Page } = await import(
        '@/app/settings/upload/category/category-mapping-group/create-mapping-group/CreateMappingGroupPage'
      );
      return {
        Component: Page,
      };
    },
  },
  {
    path: sellerMap['mapping-group'].path,
    async lazy() {
      const { default: Page } = await import(
        '@/app/settings/upload/category/category-mapping-group/mapping-group/MappingGroupPage'
      );
      return {
        Component: Page,
      };
    },
  },
  {
    path: sellerMap['edit-mapping-group'].path,
    async lazy() {
      const { default: Page } = await import(
        '@/app/settings/upload/category/category-mapping-group/edit-mapping-group/EditMappingGroupPage'
      );
      return {
        Component: Page,
      };
    },
  },
  {
    path: sellerMap['create-cafe24-category-setting'].path,
    async lazy() {
      const { default: Page } = await import(
        '@/app/settings/upload/category/category-mapping-group/create-cafe24-category-setting/CreateCafe24CategorySettingPage'
      );
      return {
        Component: Page,
      };
    },
  },
  {
    path: sellerMap['brand-group'].path,
    async lazy() {
      const { BrandGroupSettingPage: Page } = await import(
        '@/app/settings/upload/brand/brand-group-setting/BrandGroupSettingPage'
      );
      return {
        Component: Page,
      };
    },
  },
  {
    path: sellerMap['cafe24-auth'].path,
    async lazy() {
      const { default: Page } = await import('@/app/settings/platform-linkage/cafe24/cafe24-auth');
      return {
        Component: Page,
      };
    },
  },
  {
    path: sellerMap['instagram-auth'].path,
    async lazy() {
      const { default: Page } = await import('@/app/settings/platform-linkage/instagram/instagram-auth');
      return {
        Component: Page,
      };
    },
  },
  {
    path: sellerMap['template'].path,
    async lazy() {
      const { default: Page } = await import('@/app/settings/excel-template/TemplatePage');
      return {
        Component: Page,
      };
    },
  },
  {
    path: sellerMap['market-linkage-login'].path,
    async lazy() {
      const { default: Page } = await import(
        '@/app/settings/platform-linkage/components/MarketLinkageLoginPageContainer'
      );
      return {
        Component: Page,
      };
    },
  },
];

export default sellerRoutes;
